import React from 'react';
import { useParams } from 'react-router';

import useMedia from 'utils/hooks/useMedia';

import SearchBox from './SearchBox';
import DateFilters from './DateFilters';
import ObligationFilter from './ObligationFilter';
import StatusFilter from './StatusFilter';
import InstitutionFilter from './InstitutionFilter';
import ReporterFilter from './ReporterFilter';
import SubmissionsCalendar from './SubmissionsCalendar';
import AllProblematicFilter from './AllProblematicFilter';

import { Field } from 'components/UIComponents/Form';
import { Column, Row } from 'components/UIComponents/Layout';

import './style.scss';

const Filters = () => {
  const { institutionId } = useParams();

  const isSmallerThanDesktop = useMedia(
    ['(max-width: 1023px)', '(min-width: 1px)'],
    [true, false],
    false
  );

  const isMyObligationsPage = !institutionId;

  return (
    <div className="filters pb-3">
      <Row>
        <Column
          desktop={{ size: 7 }}
          widescreen={{ size: 7 }}
          fullhd={{ size: 8 }}
        >
          <Row>
            <DateFilters />
            <SearchBox />
            <StatusFilter />
            <Column
              tablet={{ size: 6 }}
              widescreen={{ size: 7 }}
              fullhd={{ size: 4 }}
            >
              <Field>
                {isMyObligationsPage ? (
                  <InstitutionFilter />
                ) : (
                  <ReporterFilter />
                )}
              </Field>
            </Column>
            {!isMyObligationsPage && <ObligationFilter />}
            <AllProblematicFilter />
          </Row>
        </Column>
        {!isSmallerThanDesktop && <SubmissionsCalendar />}
      </Row>
    </div>
  );
};

export default Filters;
